import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row", "expandButton", "collapseButton"]
  static values = { limit: Number, expanded: { type: Boolean, default: false } }

  connect() {
    this.updateView()
  }

  expand() {
    this.expandedValue = true
    this.updateView()
  }

  collapse() {
    this.expandedValue = false
    this.updateView()
  }

  updateView() {
    this.rowTargets.forEach((row, index) => {
      row.classList.toggle("hidden", !this.expandedValue && index >= this.limitValue)
    })

    if (this.hasExpandButtonTarget) {
      this.expandButtonTarget.classList.toggle("hidden", this.expandedValue)
    }

    if (this.hasCollapseButtonTarget) {
      this.collapseButtonTarget.classList.toggle("hidden", !this.expandedValue)
    }
  }
}
